import {useCallback, useEffect, useState} from "react";
import _ from 'lodash';
import {apiRequest} from '../app/Apis';

export const useDepartmentSearch = (setState,  deps) => {
  const [isRun, setIsRun] = useState(false);
  
 /* if (!isRun) {
    setIsRun(true);
  }*/
  
 return  useCallback(_.debounce(async function (value) {
     if (!value||value===''){
         setState([])
         return
     }
    const { data } = await apiRequest.get(`/departments?search=${value}`)
    if (data) {
      setState(data.data.map(item => ({ label: item.name, value: item.name })));
    }
  }, 1000), deps)
};